import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M6.416 3.523a1.586 1.586 0 0 1 3.17 0 1.586 1.586 0 0 1-3.17 0Zm-2.34.59a5.676 5.676 0 0 0-1.9 3.33.742.742 0 0 0 .62.86.487.487 0 0 0 .12.01.751.751 0 0 0 .74-.62 4.166 4.166 0 0 1 1.4-2.44.752.752 0 1 0-.98-1.14Zm8.27 3.58a.751.751 0 0 0 .74.62.615.615 0 0 0 .13-.01.742.742 0 0 0 .61-.86 5.624 5.624 0 0 0-1.9-3.33.752.752 0 1 0-.98 1.14 4.114 4.114 0 0 1 1.4 2.44Zm-8.76 1.56a1.521 1.521 0 1 0 0 3.04 1.522 1.522 0 1 0 0-3.04Zm5.85 3.06a4.6 4.6 0 0 1-1.43.23 4.51 4.51 0 0 1-1.43-.23.753.753 0 0 0-.47 1.43 6.09 6.09 0 0 0 1.9.3 5.982 5.982 0 0 0 1.89-.3.75.75 0 0 0 .48-.95.74.74 0 0 0-.94-.48Zm2.98-3.06a1.522 1.522 0 1 0 1.59 1.52 1.555 1.555 0 0 0-1.59-1.52Z';
const draw24px =
  'M3.94,12.23H3.82a.74.74,0,0,1-.62-.86A8.9,8.9,0,0,1,6.05,6.15a.75.75,0,1,1,1,1.11A7.47,7.47,0,0,0,4.68,11.6.75.75,0,0,1,3.94,12.23Zm11.41,8a.74.74,0,0,0-.95-.46,7.58,7.58,0,0,1-4.8,0,.74.74,0,0,0-.95.46.76.76,0,0,0,.47,1,9,9,0,0,0,2.73.46h.3a8.93,8.93,0,0,0,2.73-.46A.76.76,0,0,0,15.35,20.27Zm4.83-8a.74.74,0,0,0,.62-.86A8.9,8.9,0,0,0,18,6.15a.75.75,0,1,0-1,1.11,7.5,7.5,0,0,1,2.37,4.34.75.75,0,0,0,.74.63ZM12,2.27a2.52,2.52,0,1,0,2.52,2.52A2.52,2.52,0,0,0,12,2.27Zm-7,12a2.52,2.52,0,1,0,2.52,2.52A2.52,2.52,0,0,0,5,14.27Zm14,0a2.52,2.52,0,1,0,2.52,2.52A2.52,2.52,0,0,0,19,14.27Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CollaborationIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'collaboration')) as IconWithRender;

CollaborationIcon.displayName = 'CollaborationIcon';
CollaborationIcon.propTypes = Icon.propTypes;
CollaborationIcon.renderIcon = (props) => <CollaborationIcon {...props} />;
export default CollaborationIcon;
